import React from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies,ordered-imports/ordered-imports
import { Howl } from 'howler';
// eslint-disable-next-line ordered-imports/ordered-imports
import 'swiper/css';
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies,ordered-imports/ordered-imports
import { SwiperOptions } from 'swiper/types';

import { SliderLeftIcon, SliderRightIcon } from '../../icons';
import { useSlider } from '../../hooks';

import {
  StyledButtonNext,
  StyledButtonPrev,
  StyledSlide,
  StyledSlider,
} from './styled';

interface SliderProps {
  options?: SwiperOptions;
  slides: Array<React.JSX.Element>;
}

const SlideNextButton = ({ onClick }: { onClick: () => void }) => {
  const swiper = useSwiper();
  const { swiper: slider, setSlider } = useSlider();
  React.useEffect(() => {
    if (!slider && swiper) {
      setSlider(swiper);
    }
  }, []);
  return (
    <StyledButtonNext
      type="button"
      onClick={() => {
        onClick();
        swiper.slideNext();
      }}
    >
      <SliderRightIcon />
    </StyledButtonNext>
  );
};

const SlidePrevButton = ({ onClick }: { onClick: () => void }) => {
  const swiper = useSwiper();
  const { swiper: slider, setSlider } = useSlider();
  React.useEffect(() => {
    if (!slider && swiper) {
      setSlider(swiper);
    }
  }, []);
  return (
    <StyledButtonPrev
      type="button"
      onClick={() => {
        onClick();
        swiper.slidePrev();
      }}
    >
      <SliderLeftIcon />
    </StyledButtonPrev>
  );
};

const defaultOptions: SwiperOptions = {
  slidesPerView: 1,
  initialSlide: 0,
  longSwipes: false,
  threshold: 1,
};

const Slider = ({ slides, options = defaultOptions }: SliderProps) => {
  const { activeSlide, setActiveSlide, setSlider, resetSlider } = useSlider();
  const [swipe, setSwipe] = React.useState(false);

  React.useEffect(() => {
    return () => {
      resetSlider();
    };
  }, []);

  const nextAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-tap-next.mp3'],
    volume: 0.01,
  });

  const prevAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-tap-prev.mp3'],
    volume: 0.01,
  });

  const nextSwipeAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-swipe-next.mp3'],
    volume: 0.01,
  });

  React.useEffect(() => {
    if (swipe) {
      nextSwipeAudio.play();
    }
  }, [swipe]);

  return (
    <StyledSlider>
      <Swiper
        {...options}
        onSlideChange={({ activeIndex }) => {
          setActiveSlide(activeIndex);
        }}
        onSwiper={(swiper) => setSlider(swiper)}
        onTouchMove={() => setSwipe(true)}
        onTouchEnd={() => setSwipe(false)}
      >
        {activeSlide !== 0 && (
          <SlidePrevButton onClick={() => prevAudio.play()} />
        )}
        {slides.map((slide) => (
          // eslint-disable-next-line react/no-array-index-key,react/jsx-key
          <SwiperSlide id={slide.props.id}>
            <StyledSlide>{slide}</StyledSlide>
          </SwiperSlide>
        ))}
        {activeSlide < slides.length - 1 && (
          <SlideNextButton onClick={() => nextAudio.play()} />
        )}
      </Swiper>
    </StyledSlider>
  );
};

export default Slider;
